import { CUSTOM_ELEMENTS_SCHEMA, Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccordionComponent } from './accordion.component';
import { AccordionTitleBarComponent } from './accordion-title-bar/accordion-title-bar.component';
import { AccordionItemComponent } from './accordion-item/accordion-item.component';
import { MarkdownModule, MarkedOptions } from 'ngx-markdown';

@NgModule({
  declarations: [AccordionComponent, AccordionTitleBarComponent, AccordionItemComponent],
  exports: [AccordionComponent, AccordionTitleBarComponent, AccordionItemComponent],
  imports: [
    CommonModule,
    MarkdownModule.forRoot({
      markedOptions: {
        provide: MarkedOptions,
        useValue: {
          baseUrl: '',
        },
      },
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AccordionModule {}
